import {FormInstance} from 'antd/es/form';
import {isObject} from 'lodash-es';
import {useEffect} from 'react';

import {EFormMode} from 'components/form/form-types';
import {IAdditionalOptions} from 'entities/metadata';
import {loadAdditionalData} from 'modules/data/actions/field-data-actions';
import {selectUsedAdditionalOptionId} from 'modules/data/data-selectors';
import {IFormEntityData} from 'modules/data/data-types';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

const isObjectWithId = (
    value: unknown,
): value is Record<string, any> => isObject(value) && Object.keys(value).includes('id');

/**
 * Добавляет в форму поля в зависиости от выбранного значения в reference
 * @param props
 */
export const useReferenceSelectAdditionalOptions = (props: {
    key: string;
    entityName: string;
    referenceUrl: string;
    additionalOptions?: IAdditionalOptions;
    formValue?: any;
    formData?: IFormEntityData;
    form?: FormInstance;
    formMode?: EFormMode;
    areProgramSetProgramsUnique?: boolean;
}) => {
    const {
        key,
        entityName,
        additionalOptions,
        formData,
        formValue,
        referenceUrl,
        form,
        formMode,
        areProgramSetProgramsUnique,
    } = props;
    const dispatch = useAppDispatch();
    const additionalReferenceUrl = additionalOptions?.optionsField?.referenceUrl;
    const lastUsedAdditionalOptionId = useAppSelector(state => selectUsedAdditionalOptionId(entityName,
        additionalReferenceUrl || '')(state));

    useEffect(() => {
        let id: string | number | undefined;
        (async () => {
            if (additionalOptions && additionalReferenceUrl && formValue) {
                // when form is initialized value is stored as number
                if (typeof formValue === 'number' && lastUsedAdditionalOptionId !== formValue) {
                    id = formValue;
                    // then it becomes object
                } else if (isObjectWithId(formValue) && formValue?.id && lastUsedAdditionalOptionId !== formValue?.id) {
                    id = formValue?.id;
                }
                if (areProgramSetProgramsUnique && formData?.data?.programSetPrograms) {
                    if (id && (formData?.data?.programSetPrograms as any).some((set: any) => set?.program?.id === id)) {
                        return;
                    }
                }
                if (id) {
                    await dispatch(loadAdditionalData(
                        key,
                        referenceUrl,
                        additionalReferenceUrl,
                        formData?.id || '-1',
                        formValue,
                        additionalOptions?.optionsField?.isChangingFormStructure,
                        additionalOptions?.optionsField?.keepVisibleValues,
                        id,
                        entityName,
                        additionalOptions?.optionsField?.paramKey,
                        form,
                        formMode,
                        lastUsedAdditionalOptionId,
                        formData,
                    ));
                }
            }
        })();
    }, [formValue?.id]);
};
